import React from "react";
import Type from "./Type";
import Particle from "../Particle";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { MdOutlineEmail } from "react-icons/md";
import myImg from "../../Assets/人像.png";
import "./Home.css";

function Home() {
  return (
    <section>
      {/* ═══ HERO ═══ */}
      <div className="hero-wrapper">
        <Particle />
        {/* 柔和黄径向光晕（白底） */}
        <div className="hero-bg-layer" aria-hidden="true" />

        {/* 人像背后的大号装饰字 */}
        <div className="hero-bg-phrase" aria-hidden="true">
          Hey, there
        </div>

        {/* 状态徽章 */}
        <div className="hero-badge">
          <span className="hero-badge-dot" aria-hidden="true" />
          <span>Available for new opportunities</span>
        </div>

        {/* 三列布局：左标题 | 中头像 | 右职业 */}
        <div className="hero-three-col">

          {/* 左：大标题 */}
          <div className="hero-left">
            <h1 className="hero-title">
              <span className="hero-title-line">I AM</span>
              <span className="hero-title-name">CAN</span>
              <span className="hero-title-name hero-title-name--accent">XIE</span>
            </h1>
          </div>

          {/* 中：人物图片（底部渐变融入背景） */}
          <div className="hero-center">
            <div className="hero-avatar-ring">
              <img
                src={myImg}
                alt="Can Xie"
                className="hero-avatar-img"
              />
            </div>
          </div>

          {/* 右：职业 typewriter */}
          <div className="hero-right">
            <p className="hero-role-label">Currently working as</p>
            <div className="hero-typewriter">
              <Type />
            </div>
            <p className="hero-role-desc">
              Focused on AI, HCI, and turning ideas into thoughtful products &amp; research.
            </p>

            {/* 社交链接 */}
            <ul className="hero-social-list">
              <li>
                <a href="https://github.com/Volcano-Heidi" target="_blank" rel="noreferrer" className="hero-social-link" title="GitHub">
                  <AiFillGithub />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/Heidi_55555" target="_blank" rel="noreferrer" className="hero-social-link" title="Twitter / X">
                  <AiOutlineTwitter />
                </a>
              </li>
              <li>
                <a href="mailto:832303323@fzu.cn.com" className="hero-social-link" title="Email">
                  <MdOutlineEmail />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 底部滚动提示 */}
        <div className="hero-scroll-hint">
          <span>scroll</span>
          <div className="hero-scroll-line" />
        </div>
      </div>

      {/* ═══ ABOUT ═══ */}
      {/* <Home2 /> */}
    </section>
  );
}

export default Home;
